export default __webpack_public_path__ + "static/media/2-1.1e4cda64.jpg";